import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cycleAvailableDishesService } from "../../../services/menu-services/cycleAvailableDishes.service";

const getAllCycleAvailableDishes = createAsyncThunk(
    "cycleAvailableDishes/getAll",
    async (day) => cycleAvailableDishesService.getByDay(day)
);

const cycleAvailableDishesSlice = createSlice({
    name: "cycleAvailableDishes",
    initialState: {
        dishesArray: [],
        selectedDay: 1,
        status: null,
        error: null,
        trigger: 0,
    },
    reducers: {
        changeTrigger: (state) => { state.trigger += 1; },
        setSelectedDay: (state, action) => { state.selectedDay = action.payload; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCycleAvailableDishes.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getAllCycleAvailableDishes.fulfilled, (state, action) => {
                state.status = "fulfilled";
                state.dishesArray = action.payload;
            })
            .addCase(getAllCycleAvailableDishes.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.error.message;
            });
    },
});

const cycleAvailableDishesActions = {
    ...cycleAvailableDishesSlice.actions,
    getAllCycleAvailableDishes,
};

const cycleAvailableDishesReducer = cycleAvailableDishesSlice.reducer;

export { cycleAvailableDishesActions, cycleAvailableDishesReducer };
